import axios from "axios";
import constants from "../constants";
import { call, put, takeEvery } from "redux-saga/effects";
import actions from "../actions";
const {
  getLiveAttendeesSuccess,
  getLiveAttendeesError,
  getRecordedViewsSuccess,
  getRecordedViewsError,
  showModal,
  getStatsSuccess,
  getStatsNextPageSuccess,
  getStatsError,
  getDataVisualisationSuccess,
  getDataVisualisationError,
  getWebinarDataSuccess,
  getWebinarDataError,
} = actions;
const {
  GET_STATS,
  GET_LIVE_ATTENDEES,
  GET_RECORDED_VIEWS,
  MODAL_TYPE_STATS,
  GET_WEBINAR_DATA,
} = constants;

const apiGetStatisticDetails = ({ id, type }) => {
  return axios.get(`/api/v1/statistics/${id}?statistic_type=${type}`);
};
const apiGetStats = ({ page, per_page }) => {
  return axios.get(`/api/v1/statistics?page=${page}&per_page=${per_page}`);
};

const apiGetWebinarData = (webinar_id) => {
  return axios.get(`/api/v1/webinars/${webinar_id}`);
};

function* handleGetLiveAttendees(action) {
  const { payload } = action;
  const { workshop } = payload;
  try {
    const { data } = yield call(apiGetStatisticDetails, workshop);
    const users = data.users;

    yield put(getLiveAttendeesSuccess(users));
    yield put(showModal(MODAL_TYPE_STATS));
  } catch (e) {
    yield put(getLiveAttendeesError(e.response));
  }
}

function* handleGetRecordedAttendees(action) {
  const { payload } = action;
  const { workshop } = payload;
  try {
    const { data } = yield call(apiGetStatisticDetails, workshop);
    const users = data.users;

    yield put(getRecordedViewsSuccess(users));
    yield put(showModal(MODAL_TYPE_STATS));
  } catch (e) {
    yield put(getRecordedViewsError(e.response));
  }
}

function* handleGetStats(action) {
  const { payload } = action;
  const { meta } = payload;
  const { page } = meta || {};
  try {
    const getStatsSuccessAction =
      page === 1 ? getStatsSuccess : getStatsNextPageSuccess;
    const { data } = yield call(apiGetStats, meta);
    if (data.statistics) {
      yield put(getStatsSuccessAction(data.statistics, data.pages));
    } else {
      yield put(getStatsError(data));
    }
  } catch (e) {
    yield put(getStatsError(e));
  }
}

function* handleGetWebinarData(action) {
  const { payload } = action;
  const { webinar_id } = payload;
  try {
    const { data } = yield call(apiGetWebinarData, webinar_id);
    if (data.webinar) {
      yield put(getWebinarDataSuccess(data.webinar));
    } else {
      yield put(getWebinarDataError(data));
    }
  } catch (e) {
    yield put(getWebinarDataError(e));
  }
}

function* getLiveAttendeesSaga() {
  yield takeEvery(GET_LIVE_ATTENDEES, handleGetLiveAttendees);
}

function* getRecordedAttendeesSaga() {
  yield takeEvery(GET_RECORDED_VIEWS, handleGetRecordedAttendees);
}

function* getStatsSaga() {
  yield takeEvery(GET_STATS, handleGetStats);
}

function* getWebinarDataSaga() {
  yield takeEvery(GET_WEBINAR_DATA, handleGetWebinarData);
}

export {
  getLiveAttendeesSaga,
  getRecordedAttendeesSaga,
  getStatsSaga,
  getWebinarDataSaga,
};



// WEBPACK FOOTER //
// ./src/sagas/stats.js